// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1IN6y","footer":"styles_footer__fi3AC","passCodeTooltip":"styles_passCodeTooltip__rniwO"};